import React, { useEffect, useState } from "react";
import NumericInput from "../shared/NumericInput";
import PropTypes from 'prop-types'

export const PaxInput = ({onChange, value, ...rest})=>{
    const [state, setState]=useState(value || {
        Adults: 0,
        Children: 0,
        Infants: 0
    })
    const onChangeValue = (val, field) => {
        const updated = {...state, [field]: val}
        setState(updated)
        onChange?.(updated)
    }

    useEffect(()=>{
        if (value) {
            setState(value)
        }
    }, [value])

    const sepStyle = {width: 14, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "x-large", fontFamily: "monospace"}
    const numProps = {
        buttonPlacement: "none",
        digits: 0,
        min: 0,
        max: 99,
        selectOnFocus: true,
        ...rest
    }
    return <div style={{display: "flex"}}>
        <NumericInput style={{flex: 1}} placeholder="A" onChange={val=>onChangeValue(val, "Adults")} value={state.Adults} {...numProps}/>
        <div style={sepStyle}>/</div>
        <NumericInput style={{flex: 1}} placeholder="C" onChange={val=>onChangeValue(val, "Children")} value={state.Children} {...numProps}/>
        <div style={sepStyle}>/</div>
        <NumericInput style={{flex: 1}} placeholder="I" onChange={val=>onChangeValue(val, "Infants")} value={state.Infants} {...numProps}/>
    </div>
}

PaxInput.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.shape({
        Adults: PropTypes.number,
        Children: PropTypes.number,
        Infants: PropTypes.number
    })
}